import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableFreightInvoiceSupport = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableFreightInvoiceSupport);
};
